export default {
  showLoading: state => {
    return state.loading;
  },
  nationsOptions: state => {
    return state.nationOptions;
  }
};
